import { StatusChip, type StatusVariant } from '../shared/StatusChip'
import type { EmailMessageStatus, EmailRecipientStatus } from '../../types/communications'

// Message-level status (spec §8 sent list/detail): Queued is inert (neutral), Sending is the
// only "in progress" state (info, matches the job-progress card that shows alongside it), Sent
// is the terminal-success color, Failed is terminal-danger.
const MESSAGE_STATUS_VARIANT: Record<EmailMessageStatus, StatusVariant> = {
  Queued: 'neutral',
  Sending: 'info',
  Sent: 'success',
  Failed: 'danger',
}

// Recipient-row status (detail page's recipient table). Suppressed isn't a failure of sending --
// it's an opt-out/no-contact match caught before send -- so it gets warning, not danger, same
// idiom as RecipientPreviewCard's counts elsewhere in this feature.
const RECIPIENT_STATUS_VARIANT: Record<EmailRecipientStatus, StatusVariant> = {
  Pending: 'neutral',
  Sent: 'success',
  Bounced: 'danger',
  Complained: 'danger',
  Suppressed: 'warning',
  Failed: 'danger',
}

export function EmailStatusChip({ status }: { status: EmailMessageStatus }) {
  return <StatusChip variant={MESSAGE_STATUS_VARIANT[status]}>{status}</StatusChip>
}

export function EmailRecipientStatusChip({ status }: { status: EmailRecipientStatus }) {
  return <StatusChip variant={RECIPIENT_STATUS_VARIANT[status]}>{status}</StatusChip>
}
